import deliveryAddress from '../modules/deliveryAddress';
import discount from '../modules/discount';
import checkboxDiscount from '../modules/checkboxDiscount';
import postalChecks from '../modules/postalChecks';
import pickup from '../modules/pickup';
import shippingSelector from '../modules/shippingSelector';
import cartData from '../modules/cartData';
import shippingForCountry from '../modules/shippingForCountry';

const $companyInput = $('.js-data-company');
const $emailInput = $('.js-email-field');
const $invoiceMethod = $('.js-payment[data-type="3"]');

function checkInvoiceMethod() {
  const val = $companyInput.val();
  $invoiceMethod.toggle(val !== '');
}

function connectEmailToCart(email) {
  $.ajax({
    url: '/api/cart',
    type: 'POST',
    data: {
      _method: 'PUT',
      email,
    },
  });
}

const data = () => {
  deliveryAddress.initialize();
  discount.initialize();
  checkboxDiscount.initialize();
  postalChecks.initialize();
  pickup.initialize();
  shippingSelector.initialize();
  cartData.initialize();
  shippingForCountry.initialize();

  $companyInput.on('keyup', () => {
    checkInvoiceMethod();
  });

  $emailInput.on('blur', (e) => {
    connectEmailToCart(e.currentTarget.value);
  });

  checkInvoiceMethod();
};

export default data;
